module.exports = __webpack_public_path__ + "static/dominikawork8-c2f470e0055f2529df093a5294da7de0.jpg";